<template>
    <v-dialog v-model="modal" :transition="fullscreen?'dialog-bottom-transition':'dialog-transition'" persistent :fullscreen="fullscreen" :width="width" scrollable>
        <v-card class="fondo-curso-modal" :style="{'border-color':border}">
            <v-toolbar class="cerrar" :style="{'height':heightCerrar}" >
                <div class="modal-tittle">
                    <slot name="modaltittle"></slot>
                </div>
                <v-spacer> </v-spacer> 
                <button v-if="mostrarCerrar" @click="$emit('click', false)" class="hvr hvr-scale iconcerrar">
                    <v-icon class="icon">close</v-icon>
                </button>
            </v-toolbar>
            <v-card-text>
                <v-flex contain class="dialog-content" text-xs-center>
                    <slot name="modalcontent"></slot>
                </v-flex>
            </v-card-text>
        </v-card>
    </v-dialog>

</template>
<script>
    export default {
        model: {
            prop: 'modal',
            event: 'click'
        },
        props: {
            modal: Boolean,
            width: {
                type: String,
                default: '700px'
            },
            fullscreen: {
                type: Boolean,
                default: true,
            },
            mostrarCerrar: {
                type: Boolean,
                default: true
            },
            heightCerrar:{
                type: String,
                default: '45px'
            },
            border:{
                type: String,
                default: '#ff6677'
            }
        },
        data() {
            return {
            }
        },
        watch: {
            fullscreen: function(value){
                if(value){

                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../sass/helpers/variables';
    .cerrar {
        padding-bottom: 0;
        min-height: 45px;
        background: white;
        height: auto;
        box-shadow: none;
        display: flex;
        justify-content: center;
        align-items: center;

        img{
            width: 30px;
            border-radius: 45px;
            margin-top: 10px;
            margin-left: 0px;
        }
        .iconcerrar{
            position: absolute;
            top: 5px;
            right: 5px;
            border: solid $color-primary 2px;
            border-radius: 50%;
            width: 30px;
            height: 30px;
            .icon{
                color: $color-primary;
            }
        }
        .modal-tittle{
            padding: 0;
            margin-right: 10px;
        }
    }

    .dialog-content {
        max-width: 1100px;
        // max-width: 100%;
        margin: auto;
        padding: 5px;
        margin-top: -10px;
        align-items: center;
        @media (max-height: 800px){
            align-items: start;
        }
    }

    .fullscreen {
        @media (min-height: 800px){
            height: 70vh;
        }
    }
    .fondo-curso-modal {
        border-radius: 7px;
        border: solid $color-primary 2px;
    }

</style>
